import { http } from '@/http/axios.js'
// 角色列表
export function getRoleList(params) {
  return http({
    url: '/company/basic/rdbcRole/list',
    method: 'GET',
    params
  })
}
// 删除角色
export function removeRole(data) {
  return http({
    url: `/company/basic/rdbcRole/delete`,
    method: 'post',
    data
  })
}
// 新增角色
export function addRole(data) {
  return http({
    url: `/company/basic/rdbcRole/add`,
    method: 'post',
    data
  })
}
// 编辑角色
export function editRole(data) {
  return http({
    url: `/company/basic/rdbcRole/edit`,
    method: 'post',
    data
  })
}
// 角色详情
export function getRoleDetail(params) {
  return http({
    url: `/company/basic/rdbcRole/detail`,
    method: 'get',
    params
  })
}
// 菜单tree
export function getMenusTree(params) {
  return http({
    url: '/company/basic/rdbcMenu/tree',
    method: 'GET',
    params
  })
}
// 授权菜单
export function grantMenu(data) {
  return http({
    url: `/manage/role/menus`,
    method: 'post',
    data
  })
}
// 角色菜单
export function getRoleMenu(roleId) {
  return http({
    url: `/auth/role/tree/${roleId}`,
    method: 'get'
  })
}
